import { processTrackingId } from 'utils/tracking';

export const getFedexId = (barcode: string) => {
  if (barcode.length === 22 && barcode.startsWith('96')) {
    return barcode.slice(-12); // Return only the last 12
  }

  // Check if it's a FedEx 34-digit string (Express/Integrated)
  if (barcode.length === 34) {
    // Usually, the tracking number is at index 20 or 22
    return barcode.slice(-12);
  }
  // If it doesn't match FedEx patterns, return the raw data
  return barcode;
};

export const scanId = async (input: string) => {
  const fedexId = getFedexId(input);
  await processTrackingId({
    trackingId: fedexId,
    source: 'fedex',
  });
};
